module.exports = " <div class=\"item item-borderless\"> <slot></slot> <div class=hairline-top></div> <div class=hairline-bottom></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/HairlineItem.vue
// module id = 234
// module chunks = 0